import { Pipe, PipeTransform } from '@angular/core';

import { convertByteUnits } from './filesize.pipe';

@Pipe({
  name: 'bitrate',
  standalone: false,
})
export class BitratePipe implements PipeTransform {
  public transform(rate: number): string {
    return convertByteUnits(rate, ['bits/s', 'Kb/s', 'Mb/s', 'Gb/s', 'Tb/s', 'Pb/s', 'Eb/s', 'Zb/s', 'Yb/s']);
  }
}
